import { useTranslation } from 'react-i18next';
import { HelpCircle } from 'lucide-react';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';

const LEVELS = [
  { titleKey: 'cookingLevel.beginner',     pointKeys: ['cookingLevel.beginner_p1', 'cookingLevel.beginner_p2', 'cookingLevel.beginner_p3'] },
  { titleKey: 'cookingLevel.intermediate', pointKeys: ['cookingLevel.intermediate_p1', 'cookingLevel.intermediate_p2', 'cookingLevel.intermediate_p3'] },
  { titleKey: 'cookingLevel.advanced',     pointKeys: ['cookingLevel.advanced_p1'] },
];

export function CookingProficiencyTooltip() {
  const { t } = useTranslation();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <HelpCircle size={14} className="text-muted-foreground cursor-help inline-block ml-1 shrink-0" />
      </TooltipTrigger>
      <TooltipContent
        side="top"
        className="w-80 max-h-96 overflow-y-auto text-xs p-3 space-y-3"
      >
        {LEVELS.map(({ titleKey, pointKeys }) => (
          <div key={titleKey}>
            <p className="font-semibold mb-1">{t(titleKey)}</p>
            <ul className="list-disc list-inside space-y-0.5">
              {pointKeys.map((k) => (
                <li key={k}>{t(k)}</li>
              ))}
            </ul>
          </div>
        ))}
      </TooltipContent>
    </Tooltip>
  );
}
